<div style="width: auto; overflow: auto">
  <app-common-list-table
          [request]="getRequest"
          [cols]="cols"
          [globalConditionalStyle]="globalConditionalStyle"
          [globalVisualTransform]="globalVisualTransform"
          [filtering]="filter"
          [actionButtonText]="env.canAddVentas ? btnAnadir : ''"
          (actionButtonClick)="add()"
          (emitSearchText)="updateFooter()"
          (visualize)="show('info', $event)"
          (edit)="edit($event)"
          (duplicate)="duplicate($event)"
          (remove)="show('delete', $event)">
    <ng-template #thEnd>
      <th>
        <p class="d-flex justify-content-center"
           style="margin-bottom: 0">Acciones</p>
      </th>
    </ng-template>

    <ng-template #tdEnd let-data let-isFirstRow="isFirstRow">
      <td>
        <app-action-buttons
          [tourAnchorId]="isFirstRow ? 'farmerTour.rowActions' : ''"
                [hideEdit]="env.appName === 'salf' && esUsuario"
                [showDuplicate]="true"
                (duplicateRowButtonEvent)="duplicate(data.data)"       
                (editRowButtonEvent)="edit(data.data)"
                (deleteRowButtonEvent)="show('delete', data.data)"
                (showRowButtonEvent)="show('info', data.data)">
        </app-action-buttons>
      </td>
    </ng-template>

    <ng-template #footer let-col>
        <div style="font-size: 0.75em; text-align: left" *ngIf="(['finca'].includes(col.field))">
            TOTAL:
        </div>
        <div style="font-size: 0.75em; text-align: right; font-weight: bold; padding-right: 34px" *ngIf="(['cantidad', 'importe_total'].includes(col.field))">
            {{col.footer}}
        </div>
    </ng-template>
  </app-common-list-table>
</div>

@if (form; as modalForm) {
  <app-modals
    [view]="this"
    [form]="modalForm.formFields"
    [serverUrl]="env.serverUrl"
    [previousData]="model"
    [recordHasAssociatedData]="true"
    [getRequest]="getRequest"
    [deleteRequest]="deleteRequest">
  </app-modals>
}
